import React from "react";
import { Button, Card } from "react-bootstrap";
import Media from "react-media";
import { breakpoints } from "../utils/utils";
import { SmallCard } from "./SmallCard";
import { Spinner } from "./Spinner";

type Props = {
  img: {
    alt: string;
    width: string;
    height: string;
    // maxWidth: string;
    src: string;
  };
  heading: string | JSX.Element;
  subheading?: string | JSX.Element;
  cta: string;
  loading: boolean;
  onClick: () => any;
  menu?: JSX.Element;
  btnClassName?: string;
  renderAboveCta?: () => any;
  colWidths?:
    | "1"
    | "2"
    | "3"
    | "4"
    | "5"
    | "6"
    | "7"
    | "8"
    | "9"
    | "10"
    | "11"
    | "12"[];
  titleStyle?: any;
};
export const Card2: React.FC<Props> = ({
  heading,
  subheading,
  img,
  onClick,
  cta,
  menu,
  loading,
  btnClassName,
  renderAboveCta,
  colWidths,
  titleStyle,
}) => {
  const [classes, setClasses] = React.useState("");
  return (
    // <div className="col-12 col-sm-6 col-md-3 pt-5 pt-md-0">

    <Media query={{ minWidth: breakpoints.sm }}>
      {(matches) => (
        <>
          {matches && (
            <Card className={`${classes} `} style={{ width: "100%" }}>
              {menu}
              <div
                className="my-4 mx-4 text-center"
                onClick={onClick}
                onMouseEnter={() => setClasses("shadow cursor-pointer")}
                onMouseLeave={() => setClasses("")}
              >
                <div
                  style={{
                    margin: "auto",
                    height: img.height,
                    width: img.width,
                  }}
                >
                  {img.src && (
                    <img
                      alt={img.alt}
                      className="fdb-icon"
                      // width={img.width}
                      // height={img.height}
                      style={{
                        maxHeight: "100%",
                        maxWidth: "100%",
                      }}
                      src={img.src}
                      // style={{ maxWidth: img.maxWidth }}
                    />
                  )}
                </div>
                <div className="my-4">
                  <div
                    className="h5 text-truncate"
                    style={titleStyle}
                    // Card titles often truncate ("Sample Receipt Templ…");
                    // browser tooltip lets the user see the full name on
                    // hover without changing layout.
                    title={typeof heading === "string" ? heading : undefined}
                  >
                    <strong>
                      {typeof heading === "string"
                        ? heading.split("\n").map((x, idx) => (
                            <React.Fragment key={idx}>
                              {x}
                              <br />
                            </React.Fragment>
                          ))
                        : heading}
                    </strong>
                  </div>
                  {subheading && (
                    <>
                      <div className="h6 text-truncate text-muted">
                        <strong>{subheading}</strong>
                      </div>
                    </>
                  )}
                </div>
                {renderAboveCta && renderAboveCta()}
                {cta && (
                  <p className="mt-3">
                    {loading && <Spinner size="md" />}
                    {!loading && (
                      <Button
                        className={btnClassName || "btn--card2"}
                        // outline-primary reads as a clickable button instead
                        // of grey-secondary which scanned as disabled. The
                        // whole card is also clickable, so this button is
                        // mostly a visual anchor for the action.
                        variant="outline-primary"
                      >
                        {cta}
                      </Button>
                    )}
                  </p>
                )}
              </div>
            </Card>
          )}
          {!matches && (
            <SmallCard
              cta={cta}
              heading={heading}
              img={img}
              loading={loading}
              onClick={onClick}
              btnClassName={btnClassName}
              colWidths={colWidths}
            />
          )}
        </>
      )}
    </Media>
    // </div>
  );
};

Card2.defaultProps = {
  titleStyle: {},
};
